export const COLOR_PRIMARY = "#44A659";
export const COLOR_SECONDARY = "#69a644";

export const COLOR_WHITE = "#ffffff";

export const COLOR_GRAY_300 = "#D1D5DB";
